const Timer = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_TitleSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'titleSettings',
        },
        options: {
          text: {
            type: 'Text',
            order: 0,
          },
          textColor: {
            type: 'HexColor',
            order: 1,
          },
          textAlignment: {
            type: 'LeftCenterRight',
            order: 2,
          },
          textStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          textWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          textSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          textLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
        },
      },
      Menu_TimerSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'timerSettings',
        },
        options: {
          timeSelectionText: {
            type: 'Text',
            order: 0,
          },
          timerNumberColor: {
            type: 'HexColor',
            order: 2,
          },
          timerNumberWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 3,
          },
          timerNumberSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 4,
          },

          timerTextColor: {
            type: 'HexColor',
            order: 5,
          },
          timerTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
          timerTextSize: {
            type: 'RangePx',
            data: {
              max: 12,
              min: 2,
              step: 1,
            },
            order: 7,
          },
        },
      },
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 1300,
        renderOptions: {
          controlKey: 'OtherSettings',
        },
        options: {
          backgroundColor: {
            type: 'HexColor',
          },
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 13,
            options: {
              padding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'Timer_1',
      name: 'Timer_1',
      type: 'Timer',
      data: {},
      customization: {
        text: '',
        textAlignment: 'center',
        textSize: '24px',
        textColor: '#FFFFFF',
        textStyle: 'normal',
        textWeight: '500',
        textLetterSpacing: '0px',

        backgroundColor: '#d7435f',
        padding: '15px 15px 15px 15px',

        timeSelectionText: '29/07/2030 17:40',
        timerNumberColor: '#FFFFFF',
        timerNumberSize: '20px',
        timerNumberWeight: '400',
        timerTextColor: '#FFFFFF',
        timerTextSize: '12px',
        timerTextWeight: '400',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Timer+1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default Timer;
